import { describeFields, FieldWidget } from '../common/fields';
import { LegacyExamTypeSchema } from './schemas';

export const LEGACY_EXAM_TYPE_FIELDS = describeFields(LegacyExamTypeSchema, {
  subject: { widget: FieldWidget.Text },
  type: { widget: FieldWidget.Text },
  creationDatetime: { widget: FieldWidget.DateTime },
  editDatetime: { widget: FieldWidget.DateTime },
  label: {},
  unitPayRate: { widget: FieldWidget.Text },
  unitPayDuration: { widget: FieldWidget.Text },
});
